import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { SelectChangeEvent } from '@mui/material';

import '../reportStyles.scss';
import { errorNormalizer } from '../../../shared/Helpers/functions';
import { CustomButton, MultipleSelect } from '../../../shared/uiComponents';
import { ReportFilters, downloadFile } from '../helpers';
import { REPORT_GENERATION_MESSAGE } from '../../../shared/Helpers/constants';
import { DispatchProperties, useSelector } from '../../../redux/store';
import {
	getAuthorizationReport,
	getInsuranceAuthorizationSessionTypes,
} from '../../../redux/State/clientSlice/insuranceAuthorizationSlice';
import { SelectDataProperties } from '../../../shared/uiComponents/Dropdown/searchSelect';
import { setAuthorizationSessionTypeIds } from '../../../redux/State/clientSlice/billingSlice';

const AuthorizationReport = () => {
	const dispatch = useDispatch<DispatchProperties>();

	const { clientIds, authorizationSessionTypeIds, timeError } = useSelector((state) => state.billing.billingFilters);
	const [sessionTypesData, setSessionTypesData] = useState<SelectDataProperties[]>([]);
	const loading = useSelector((state) => state.authorization.loading);

	useEffect(() => {
		dispatch(getInsuranceAuthorizationSessionTypes())
			.then(unwrapResult)
			.then((response) => {
				if (!response) return;
				const data: SelectDataProperties[] = response
					.filter((x: { id: string; name: string }) => !x.name.toLowerCase().includes('non-billable'))
					.map((type: { id: string; name: string }) => ({
						id: type.id,
						name: type.name,
					}));
				setSessionTypesData(data);
			});
	}, [dispatch]);

	const downloadHandler = useCallback(() => {
		toast(REPORT_GENERATION_MESSAGE);

		dispatch(
			getAuthorizationReport({
				clientIds,
				authorizationSessionTypeId: authorizationSessionTypeIds,
			}),
		)
			.then(unwrapResult)
			.then((response) => downloadFile(response))
			.catch(errorNormalizer);
	}, [dispatch, clientIds, authorizationSessionTypeIds]);

	const onSessionTypesChange = (event: SelectChangeEvent<string[]>) => {
		const { value } = event.target;
		dispatch(setAuthorizationSessionTypeIds(value));
	};

	return (
		<>
			<ReportFilters
				showUsers={false}
				isMultipleSelect
				showOnlyNew={false}
				showDateRange={false}
				showShorcuts={false}
			/>
			<div style={{ width: '250px', marginBottom: '16px' }}>
				<MultipleSelect
					label="Session Types:"
					initialValue={authorizationSessionTypeIds}
					data={sessionTypesData}
					setValue={onSessionTypesChange}
				/>
			</div>
			<div style={{ width: 'max-content' }}>
				<CustomButton title="Download" onClick={downloadHandler} loading={loading} disabled={timeError} />
			</div>
		</>
	);
};

export default AuthorizationReport;
